import {
	Component,
	OnInit,
	forwardRef,
	ViewEncapsulation,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { FnInputValueAccessor } from '../../../core/model/fn-input.value.accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnUiFieldMetaDataService } from '../service/fn-ui-field-metadata.service';
/**
 * This Component is Used To Create Radio Button.
 * To use this component import FnInputModule in Module.
 */
@Component({
	selector: 'fn-radio',
	templateUrl: './fn-input-radio.component.html',
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FnInputRadioComponent),
			multi: true,
		},
	],
})
export class FnInputRadioComponent extends FnInputValueAccessor<any> {
	constructor(private fieldMetaDataSvcs: FnUiFieldMetaDataService) {
		super();
	}
	@Input() label: string;
	@Input() name = '';
	@Input() id = '';
	@Input() labelClass = '';
	@Output() clickCallback: EventEmitter<string> = new EventEmitter();

	clickAction(eventId: any) {
		this.clickCallback.emit(eventId);
	}
}
